import { Link, LinkProps } from 'react-router';

type TrackableLinkProps = LinkProps & {
    trackingKey: string;
};

export function TrackableLink({ trackingKey, ...props }: TrackableLinkProps): JSX.Element {
    return <Link data-gtm-element={trackingKey} {...props} />;
}
